import { DetailsContainer } from './DetailsContainer';

const Education = ({ heading, data, color }) => {
  return (
    <div className="flex flex-col mb-7 mt-7">
      <h3 className="text-3xl font-semibold mb-5">{heading}</h3>
      {data.map((d) => (
        <div key={d.id} className="pl-14 relative mb-5">
          <DetailsContainer
            key={d.education_id}
            title={d.major}
            subtitle={d.school_name}
            dates={d.dates}
            summary={d.summary}
            color={color}
          />
        </div>
      ))}
    </div>
  );
};

export default Education;
